import PayPeriodCard from './cards/PayPeriodCard';
import TemplateCard from './cards/TemplateCard';
import MappingCard from './cards/MappingCard';
import EmployeeMappingCard from './cards/EmployeeMappingCard';
import PreviewCard from './cards/PreviewCard';
import ResultCard from './cards/ResultCard';
import type { SmartImportChat } from './useSmartImportChat';
import type { SmartImportStepKind } from './types';

/** Picks the one interactive card for the chat's current Smart Import step. */
export default function SmartImportCard({ step, chat }: { step: SmartImportStepKind; chat: SmartImportChat }) {
	switch (step) {
		case 'pay_period':
			return <PayPeriodCard chat={chat} />;
		case 'template':
			return <TemplateCard chat={chat} />;
		case 'mapping':
			return <MappingCard chat={chat} />;
		case 'employees':
			return <EmployeeMappingCard chat={chat} />;
		case 'preview':
			return <PreviewCard chat={chat} />;
		case 'result':
			return <ResultCard chat={chat} />;
		default:
			return null;
	}
}
